var map = {
	"./en-US/cardgolegends/banner.jpg": 66506,
	"./en-US/guide/live-course-guide.png": 87927,
	"./en-US/guide/notification-guide.png": 72192,
	"./en-US/live-course/card-preview.png": 28159,
	"./en-US/login/web_login_1_tc.png": 41003,
	"./en-US/login/web_login_2_tc.png": 73002,
	"./en-US/login/web_login_3_tc.png": 24949,
	"./en-US/login/web_login_banner.png": 96770,
	"./en-US/personal/certificate.png": 48549,
	"./en-US/personal/g_certificate.png": 95551,
	"./en-US/pvp/event-double-elo.png": 75995,
	"./en-US/pvp/icon-double-elo.svg": 88712,
	"./en-US/sticker/bubu-1.png": 8995,
	"./en-US/sticker/bubu-2.png": 72136,
	"./en-US/sticker/bubu-3.png": 12081,
	"./en-US/sticker/bubu-4.png": 75966,
	"./en-US/sticker/bubu-5.png": 63655,
	"./en-US/sticker/bubu-6.png": 78828,
	"./en-US/sticker/bubu-7.png": 61717,
	"./en-US/sticker/bubu-8.png": 9714,
	"./en-US/sticker/bubu-9.png": 75067,
	"./en-US/sticker/hjj-1.png": 36655,
	"./en-US/sticker/hjj-2.png": 14196,
	"./en-US/sticker/hjj-3.png": 35325,
	"./en-US/sticker/hjj-4.png": 42530,
	"./en-US/sticker/hjj-5.png": 89835,
	"./en-US/sticker/hjj-6.png": 24432,
	"./en-US/sticker/hjj-7.png": 56537,
	"./en-US/sticker/hjj-8.png": 24622,
	"./en-US/sticker/hjj-9.png": 98263,
	"./en-US/verification/verification-shield.png": 93464,
	"./ja-JP/cardgolegends/banner.jpg": 62218,
	"./ja-JP/guide/live-course-guide.png": 12695,
	"./ja-JP/guide/notification-guide.png": 6656,
	"./ja-JP/live-course/card-preview.png": 28671,
	"./ja-JP/login/web_login_1_tc.png": 96299,
	"./ja-JP/login/web_login_2_tc.png": 79722,
	"./ja-JP/login/web_login_3_tc.png": 37365,
	"./ja-JP/login/web_login_banner.png": 20162,
	"./ja-JP/personal/certificate.png": 44133,
	"./ja-JP/personal/g_certificate.png": 1471,
	"./ja-JP/pvp/event-double-elo.png": 60827,
	"./ja-JP/pvp/icon-double-elo.svg": 39400,
	"./ja-JP/sticker/bubu-1.png": 93891,
	"./ja-JP/sticker/bubu-2.png": 8616,
	"./ja-JP/sticker/bubu-3.png": 6481,
	"./ja-JP/sticker/bubu-4.png": 65470,
	"./ja-JP/sticker/bubu-5.png": 83783,
	"./ja-JP/sticker/bubu-6.png": 63724,
	"./ja-JP/sticker/bubu-7.png": 32821,
	"./ja-JP/sticker/bubu-8.png": 3666,
	"./ja-JP/sticker/bubu-9.png": 17883,
	"./ja-JP/sticker/hjj-1.png": 46063,
	"./ja-JP/sticker/hjj-2.png": 71572,
	"./ja-JP/sticker/hjj-3.png": 4605,
	"./ja-JP/sticker/hjj-4.png": 354,
	"./ja-JP/sticker/hjj-5.png": 21483,
	"./ja-JP/sticker/hjj-6.png": 50192,
	"./ja-JP/sticker/hjj-7.png": 56441,
	"./ja-JP/sticker/hjj-8.png": 24526,
	"./ja-JP/sticker/hjj-9.png": 70103,
	"./ja-JP/verification/verification-shield.png": 86360,
	"./zh-CN/cardgolegends/banner.jpg": 5788,
	"./zh-CN/guide/live-course-guide.png": 96789,
	"./zh-CN/guide/notification-guide.png": 65414,
	"./zh-CN/live-course/card-preview.png": 5701,
	"./zh-CN/login/web_login_1_tc.png": 83601,
	"./zh-CN/login/web_login_2_tc.png": 55236,
	"./zh-CN/login/web_login_3_tc.png": 79271,
	"./zh-CN/login/web_login_banner.png": 47072,
	"./zh-CN/personal/certificate.png": 76803,
	"./zh-CN/personal/g_certificate.png": 4277,
	"./zh-CN/pvp/event-double-elo.png": 77281,
	"./zh-CN/pvp/icon-double-elo.svg": 92614,
	"./zh-CN/sticker/bubu-1.png": 54881,
	"./zh-CN/sticker/bubu-2.png": 13802,
	"./zh-CN/sticker/bubu-3.png": 29363,
	"./zh-CN/sticker/bubu-4.png": 31964,
	"./zh-CN/sticker/bubu-5.png": 84229,
	"./zh-CN/sticker/bubu-6.png": 56398,
	"./zh-CN/sticker/bubu-7.png": 55895,
	"./zh-CN/sticker/bubu-8.png": 39536,
	"./zh-CN/sticker/bubu-9.png": 45785,
	"./zh-CN/sticker/hjj-1.png": 6993,
	"./zh-CN/sticker/hjj-2.png": 2234,
	"./zh-CN/sticker/hjj-3.png": 49987,
	"./zh-CN/sticker/hjj-4.png": 90092,
	"./zh-CN/sticker/hjj-5.png": 26005,
	"./zh-CN/sticker/hjj-6.png": 40254,
	"./zh-CN/sticker/hjj-7.png": 92743,
	"./zh-CN/sticker/hjj-8.png": 91648,
	"./zh-CN/sticker/hjj-9.png": 69769,
	"./zh-CN/verification/verification-shield.png": 23530,
	"./zh-TW/cardgolegends/banner.jpg": 83836,
	"./zh-TW/guide/live-course-guide.png": 13941,
	"./zh-TW/guide/notification-guide.png": 44966,
	"./zh-TW/live-course/card-preview.png": 85253,
	"./zh-TW/login/web_login_1_tc.png": 61649,
	"./zh-TW/login/web_login_2_tc.png": 33284,
	"./zh-TW/login/web_login_3_tc.png": 57319,
	"./zh-TW/login/web_login_banner.png": 80000,
	"./zh-TW/personal/certificate.png": 54851,
	"./zh-TW/personal/g_certificate.png": 37205,
	"./zh-TW/pvp/event-double-elo.png": 55329,
	"./zh-TW/pvp/icon-double-elo.svg": 67258,
	"./zh-TW/sticker/bubu-1.png": 49281,
	"./zh-TW/sticker/bubu-2.png": 91850,
	"./zh-TW/sticker/bubu-3.png": 23763,
	"./zh-TW/sticker/bubu-4.png": 26364,
	"./zh-TW/sticker/bubu-5.png": 62277,
	"./zh-TW/sticker/bubu-6.png": 50798,
	"./zh-TW/sticker/bubu-7.png": 50295,
	"./zh-TW/sticker/bubu-8.png": 33936,
	"./zh-TW/sticker/bubu-9.png": 40185,
	"./zh-TW/sticker/hjj-1.png": 86769,
	"./zh-TW/sticker/hjj-2.png": 65658,
	"./zh-TW/sticker/hjj-3.png": 29763,
	"./zh-TW/sticker/hjj-4.png": 53516,
	"./zh-TW/sticker/hjj-5.png": 5781,
	"./zh-TW/sticker/hjj-6.png": 20030,
	"./zh-TW/sticker/hjj-7.png": 72519,
	"./zh-TW/sticker/hjj-8.png": 71424,
	"./zh-TW/sticker/hjj-9.png": 49545,
	"./zh-TW/verification/verification-shield.png": 73898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20625;